<template>
    <v-app class="grey lighten-4">
      <v-content class="mx-4 mb-4">
        <router-view></router-view>
      </v-content>

    </v-app>
</template>

<script>
export default {
  name: 'App',
  components: {},
  data () {
    return {
      //
    }
  },
  computed: {
    isLoggedIn() {
      return this.$store.getters.isLoggedIn;
    }
  },
  methods: {
    logout() {
      this.$store.dispatch('logout').then(() => {
        this.$router.push("/login");
      });
    }
  },
}
</script>

